<template>
  <div class="home-widget col-sm-12 col-md-12 col-lg-4">
    <spinner-loader v-if="loading" :height="280" />
    <div class="widget-body" v-else>
      <p class="widget-title"><font-awesome-icon icon="terminal" /> Your last Queries:</p>
      <render-index-table :queries="$store.state.queries.items" :fields="fields"/>
    </div>
  </div>
</template>

<script>
  import RenderIndexTable from '../../views/queries/RenderIndexTable.vue';
  import SpinnerLoader from '../Spinner-loader.vue';
  export default {
    components: {
      SpinnerLoader,
      RenderIndexTable
    },
    data() {
      return {
        loading: true,
        fields: ['name', 'actions']
      }
    },
    computed: {

    },
    beforeCreate() {
      this.$store.commit('queries/SET_PAGINATION_LIMIT', 5);
      this.$store.dispatch('queries/fetch').then(() => {
        this.loading = false;
        this.$store.commit('queries/SET_PAGINATION_LIMIT', 50);
      });
    },
  }
</script>
